import { render } from "./LoginBlock.vue?vue&type=template&id=3298bd33"
import script from "./LoginBlock.vue?vue&type=script&lang=js"
export * from "./LoginBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__